import axios from "axios"
import TokenService from "@/services/TokenService"
import { errorHandlers } from "@/services/ErrorHandler"

const localApi = axios.create({
  baseURL: `${window.location.origin}`
})

const apiV1 = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL
})

const axiosInstances = { localApi, apiV1 }

Object.values(axiosInstances).forEach((instance) => {
  instance.setAuthorization = (token) => {
    instance.defaults.headers.Authorization = `Bearer ${token}`
  }

  instance.interceptors.request.use(
    (config) => {
      const token = TokenService.getToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      switch (error?.response?.status) {
        case 401:
          errorHandlers[401]()
          break
        case 422:
          break
        default:
          errorHandlers.default(error.response?.data.message ?? error.message)
      }

      return Promise.reject(error)
    }
  )
})

export { localApi, apiV1, axiosInstances }
